import React from "react";
import '../../styles/components/settings/settings-section.scss';
import '../../styles/components/settings/account-section.scss';
import settingsPage from "../../services/settings/settingsPage";
import Button from "../common/Button";
import {AccountInfoSection} from "../../modules/settings/section-account-info/AccountInfoSection";
import ExternalLink from "../common/ExternalLink";
import {baseUrlForWebsite} from "../../client/PlaygroundSettings";

export default function AccountSection() {
  return (
    <div className="settings-section account-section">
      <header>Account</header>
      <main className="settings">
        <AccountInfoSection />
        <Button text="Sign Out" onClick={()=> settingsPage.signOut()} />
        <ExternalLink
          url={`${baseUrlForWebsite}/my-account/forward-to-account-deletion`}
          title={"Delete Account on Playground Site"}
          additionalClassName={'danger pushToBottom'}
        />
      </main>
    </div>
  );
}
